const header = document.querySelector('header');
const updateHeader = () => {
	const threshold = parseFloat(getComputedStyle(document.documentElement).fontSize) * 9;
	header.classList.toggle('cond', window.scrollY >= threshold);
};
window.addEventListener('scroll', updateHeader, { passive: true });
updateHeader();